import { Component } from '@angular/core';
import { ICellRendererAngularComp } from '@ag-grid-community/angular';
import { TranslateModule } from '@ngx-translate/core';
import { RouterLinkEnhancedDirective } from 'shared/directives/router-link-enhanced.directive';
import cloneDeep from 'lodash-es/cloneDeep';
import isFunction from 'lodash-es/isFunction';
import { ICellRendererParams } from '@ag-grid-community/core/dist/esm/es6/rendering/cellRenderers/iCellRenderer';

interface Link {
    text: string;
    url: string;
    tooltip?: string;
    disabled?: boolean;
    computeDisabledState?: (data: any) => boolean;
    computeVisibleState?: (data: any) => boolean;
    computeTooltip?: (data: any) => string;
    computeUrl?: (data: any) => string;
}

interface LinkRendererParams {
    links: Link[];
    alignment?: 'left' | 'center' | 'right';
}

@Component({
    selector: 'app-links',
    templateUrl: './link-renderer.component.html',
    styleUrls: ['./link-renderer.component.scss'],
    imports: [TranslateModule, RouterLinkEnhancedDirective],
})
export class LinkRendererComponent implements ICellRendererAngularComp {
    public links: Link[] = [];
    public computedFields: { [key: string]: any }[] = [];
    protected alignment?: 'left' | 'center' | 'right';

    protected computableFieldMap: [keyof Link, keyof Link][] = [
        ['url', 'computeUrl'],
        ['disabled', 'computeDisabledState'],
        ['tooltip', 'computeTooltip'],
        // ["visible", "computeVisibleState"],
    ];

    public agInit(params: ICellRendererParams): void {
        this.updateComponentState(params);
    }

    public refresh(params: ICellRendererParams): boolean {
        this.updateComponentState(params);
        return true;
    }

    private updateComponentState(params: ICellRendererParams): void {
        // Access custom parameters from cellRendererParams
        const cellRendererParams = (params.colDef?.cellRendererParams || {}) as LinkRendererParams;

        this.links = cloneDeep(cellRendererParams.links || []);
        this.computedFields = [];
        this.alignment = cellRendererParams.alignment;

        this.links.forEach((link, index) => {
            const computedValues: { [key: string]: any } = {};
            link.text = params.value;

            this.computableFieldMap.forEach(([field, computeFnKey]) => {
                const computeFn = link[computeFnKey];
                if (isFunction(computeFn)) {
                    computedValues[field] = computeFn(params.data);
                }
            });

            this.computedFields.push(computedValues);
        });
    }
}
